import { render, staticRenderFns } from "./CreateOption.vue?vue&type=template&id=50f01496&scoped=true"
import script from "./CreateOption.vue?vue&type=script&lang=js"
export * from "./CreateOption.vue?vue&type=script&lang=js"
import style0 from "./CreateOption.vue?vue&type=style&index=0&id=50f01496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f01496",
  null
  
)

export default component.exports